<template>





        <v-parallax dark  :src="require(`../../assets/images/bg/${$vuetify.theme.dark ? 'bg-dark' : 'bg-light'}.png`)"  height="1100">
            <v-row align="center" justify="center">
                <v-col class="text-center" cols="4">



                    <base-card>

                        <div slot="card-header">


                            <p class="text-center">
                                LOGIN
                            </p>


                        </div>
                        <div slot="card-body">
                            <v-row>


                                <v-col cols="12" sm="12">
                                    <v-text-field v-model="email" :rules="[rules.required, rules.email]" label="E-MAIL">
                                    </v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" sm="12">
                                    <v-text-field v-model="password" :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                                        :rules="[rules.required, rules.min]" :type="show1 ? 'text' : 'password'"
                                        name="input-10-1" label="PASSWORD" hint="At least 8 characters" counter
                                        @click:append="show1 = !show1"></v-text-field>
                                </v-col>


                            </v-row>

                            <v-row>
                                <v-checkbox v-model="agreement" :rules="[rules.required]" color="deep-purple">
                                    <template v-slot:label>
                                        I agree to the&nbsp;
                                        <a href="#" @click.stop.prevent="dialog = true">Terms of Service</a>
                                        &nbsp;and&nbsp;
                                        <a href="#" @click.stop.prevent="dialog = true">Privacy Policy</a>*
                                    </template>
                                </v-checkbox>
                                <v-btn color="red" @click="goDashboard1()" block>
                                    SIGN IN
                                </v-btn>
                            </v-row>
                        </div>
                    </base-card>




                </v-col>
            </v-row>
        </v-parallax>

</template>

<script>
    import BaseCard from "../../components/Base/BaseCard.vue";


    export default {
        components: {
            BaseCard,


        },
        data() {
            return {
                show1: false,
                show2: true,
                show3: false,
                show4: false,
                password: 'Password',
                rules: {
                    required: value => !!value || 'Required.',
                    min: v => v.length >= 8 || 'Min 8 characters',
                    emailMatch: () => (`The email and password you entered don't match`),
                },
            }
        },
        methods: {
             goDashboard1() {
				return this.$router.push("/dashboard/dashboard1");
			},
        },
    }
</script>